// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3836) return "3836.54383d22d81e9dfb.1742301268865.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "6e82e7bff1ec5318" + ".js";
};